// 全局上游代理池管理页：代理节点是 daemon 级资源，不绑定到单台机器详情。

import { createFileRoute } from "@tanstack/react-router";
import { ProxyProfilesManager } from "@/components/proxy/ProxyProfilesManager";
import { useSession } from "@/hooks/useSession";

export const Route = createFileRoute("/proxy-profiles")({
  component: ProxyProfilesRoute,
});

function ProxyProfilesRoute() {
  const session = useSession();
  const canWrite = session.data?.can_write ?? false;

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-lg font-semibold">上游代理池</h1>
        <p className="mt-1 text-xs text-[hsl(var(--muted-foreground))]">
          统一维护可分配给各 agent 启动槽位的上游代理节点。
        </p>
      </div>
      <ProxyProfilesManager canWrite={canWrite} />
    </div>
  );
}
